import { Inbox, type LucideIcon } from 'lucide-react'

interface Props {
  icon?: LucideIcon
  title: string
  description?: string
  emoji?: string  // Legacy prop, ignored; kept for backward compat
}

export default function EmptyState({ icon: Icon = Inbox, title, description }: Props) {
  return (
    <div className="empty-state">
      <Icon className="empty-state-icon" />
      <div className="empty-state-title">{title}</div>
      {description && <div className="empty-state-text">{description}</div>}
    </div>
  )
}
